import { Messages } from '~src/codegen/Localize';
import { RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';

export type RemoteAgentState = Readonly<{
  stateLabel: string;
  stateText: string;
  stateImage: string;
  stateClass: string;
}>;

/*
 * Register remote agent states here for the remote agent presence icon
 */
export function getRemoteAgentStates() {
  return {
    'CONNECTED': {
      stateLabel: Messages.remoteAgentConnectionStatus_connected_short(),
      stateText: Messages.remoteAgentConnectionStatus_connected(),
      stateImage: 'status_active_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-connected'
    },
    'DISCONNECTED': {
      stateLabel: Messages.remoteAgentConnectionStatus_disconnected_short(),
      stateText: Messages.remoteAgentConnectionStatus_disconnected(),
      stateImage: 'status_down_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'NOT_IN_SERVICE_MODE': {
      stateLabel: Messages.remoteAgentConnectionStatus_notInServiceMode_short(),
      stateText: Messages.remoteAgentConnectionStatus_notInServiceMode(),
      stateImage: 'status_down_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'NOT_RESPONSIVE': {
      stateLabel: Messages.remoteAgentConnectionStatus_notResponding_short(),
      stateText: Messages.remoteAgentConnectionStatus_notResponding(),
      stateImage: 'status_down_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'NEEDS_UPGRADE': {
      stateLabel: Messages.remoteAgentConnectionStatus_needsUpgrade_short(),
      stateText: Messages.remoteAgentConnectionStatus_needsUpgrade(),
      stateImage: 'status_error_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'THROTTLED': {
      stateLabel: Messages.remoteAgentConnectionStatus_throttled_short(),
      stateText: Messages.remoteAgentConnectionStatus_throttled(),
      stateImage: 'status_error_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-warning'
    },
    'UNKNOWN': {
      stateLabel: null,
      stateText: null,
      stateImage: '',
      stateClass: 'tb-remote-agent-presence-icon'
    }
  } as { readonly [s in RemoteAgentConnectionStatus]: RemoteAgentState };
}
